import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.inputs = this.element.querySelectorAll("input, select, textarea");
    this.inputs.forEach(input => {
      input.addEventListener("change", this.checkConditions.bind(this));
    });
  }

  checkConditions(e) {
    var inputName = e.target.name; // "field_#{field.id}_value"
    var inputValue = e.target.value;
    var fieldId = inputName.split("_")[1];
    // Find all the conditional fields that depend on this field
    var dependentFields = this.element.querySelectorAll(`[data-conditional-on-field-id="${fieldId}"]`);
    dependentFields.forEach(dependentField => {
      var desiredValue = dependentField.getAttribute("data-conditional-on-value").toLowerCase();
      var desiredValues = [desiredValue];

      // Add synonyms.  This is to handle situations where we depend on "Yes" or "No" but the values are "true" / "false".
      if (desiredValue == "yes") {
        desiredValues.push("true");
      } else if (desiredValue == "no") {
        desiredValues.push("false");
      } else if (desiredValue == "true") {
        desiredValues.push("yes");
      } else if (desiredValue == "false") {
        desiredValues.push("no");
      }

      if (desiredValues.includes(inputValue.toLowerCase())) {
        dependentField.classList.remove("hidden");
      } else {
        dependentField.classList.add("hidden");

        // Also clear whatever values we had
        var inputs = dependentField.querySelectorAll("input, select, textarea");
        inputs.forEach(input => {
          if (input.type == "checkbox" || input.type == "radio") {
            input.checked = false;
          } else {
            input.value = "";
          }
        });
      }
    });
  }
}